export const figure21c = {
chart: {
type: 'line',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
height: 300,
plotBackgroundColor: null,
plotBorderWidth: null,
},
credits: {
enabled: false
},
title: {
text: 'Ouganda'
},
subtitle: {
text: null
},
xAxis: {
categories: ['2010','2011','2012','2014', '2016', '2019', '2020']
},
labels: {
format: '{value}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
yAxis: {
min: 0,
max: 3000,
tickInterval: 1000,
labels: {
	     format: '{value:,.0f}',
	     style: {
			     fontWeight: 'normal',
			     color: '#999999',
			     fontSize: '12px'
		     },
     },
title: {
text: null,
},
},
plotOptions: {
series: {
 marker: {
		 enabled: false,
		 states: {
				  hover: {
						 enabled: false
					 }
			  }
	 }
},	
line: {
dataLabels: {
enabled: false
},
enableMouseTracking: true
}
},
legend: {
enabled: false,
},
colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
series: [{
name: 'Petits producteurs',
data: [594, 651, 644, 545, 519, 989, 673]
}, {
name: 'Gros producteurs',
data: [1168, 1268, 1139, 1396, 963, 2874, 1436]
},{
name: 'Petits producteurs de sexe féminin	',
data: [498, 572, 559, 471, 496, 1024, 564]
},{
name: 'Petits producteurs de sexe masculin',
data: [635, 692, 690, 590, 532, 891, 740]
}]
}

